import { Card, CardContent } from 'src/shared/components/ui/cards/card'
import { cn } from 'src/shared/utils/cn'

type AuthCardProps = {
  children: React.ReactNode
  className?: string
  contentClassName?: string
}

const AuthCard = ({ children, className, contentClassName }: AuthCardProps) => {
  return (
    <Card className={cn('flex w-full flex-col items-center border-0 px-[5%] shadow-none md:px-6', className)}>
      <CardContent
        className={cn('flex h-[calc(100vh-20px)] w-full flex-col justify-between px-0 py-5 md:py-8', contentClassName)}
      >
        {children}
      </CardContent>
    </Card>
  )
}

export default AuthCard
